import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root',
})
export class LeadPriorityService {
  constructor(private ws: PostmethodService) {}

  getLeadPriorityList(): Observable<any> {
    const requestPayload = { flag: 'list' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'leadPrioritiesMaster'
    );
  }

  createLeadPriorityMaster(data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'create' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'leadPrioritiesMaster'
    );
  }

  updateLeadPriorityMaster(id: number, data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'update', id };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'leadPrioritiesMaster'
    );
  }

  deleteLeadPriorityMaster(id: number): Observable<any> {
    const requestPayload = { id, flag: 'delete' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'leadPrioritiesMaster'
    );
  }
}
